"use client";
import { jsx } from "react/jsx-runtime";
import { CustomSingleSkeleton } from "./CustomSingleSkeleton/CustomSingleSkeleton.js";
import { CheckboxSkeleton } from "./MultiElementVariants/CheckboxSkeleton.js";
import { NumberedStepSkeleton } from "./MultiElementVariants/NumberedStepSkeleton.js";
import { RadioButtonSkeleton } from "./MultiElementVariants/RadioButtonSkeleton.js";
import { TextMultipleLines } from "./MultiElementVariants/TextMultipleLines.js";
import { HIDDEN_TEXT_DEFAULT, COMPONENT_NAME } from "./constants.js";
import { SkeletonVariant } from "./enums.js";
import { singleElementVariants } from "./singleElementVariants.js";
import { getDataTestId } from "../../Util/index.js";
const Skeleton = (props) => {
  const {
    hiddenText = HIDDEN_TEXT_DEFAULT,
    variant,
    width,
    uniqueId
  } = props;
  let height;
  let lines;
  let sx;
  if (variant === SkeletonVariant.TextMultipleLines) {
    lines = props.lines;
  }
  if (variant === SkeletonVariant.Rectangular || variant === SkeletonVariant.Circular) {
    height = props.height;
  }
  if (variant === void 0) {
    height = props.height;
    sx = props.sx;
  }
  const multiElementVariants = {
    [SkeletonVariant.Checkbox]: /* @__PURE__ */ jsx(CheckboxSkeleton, { hiddenText, width }),
    [SkeletonVariant.NumberedStep]: /* @__PURE__ */ jsx(NumberedStepSkeleton, { hiddenText, width }),
    [SkeletonVariant.RadioButton]: /* @__PURE__ */ jsx(RadioButtonSkeleton, { hiddenText, width }),
    [SkeletonVariant.TextMultipleLines]: /* @__PURE__ */ jsx(
      TextMultipleLines,
      {
        hiddenText,
        lines,
        variant: SkeletonVariant.TextMultipleLines,
        width
      }
    )
  };
  if (variant !== void 0 && variant in multiElementVariants) {
    return multiElementVariants[variant];
  }
  let computedHeight = height;
  let computedWidth = width;
  let computedSx = sx;
  if (variant !== void 0 && variant in singleElementVariants) {
    const element = singleElementVariants[variant];
    if ("height" in element) {
      computedHeight = height ?? element.height;
    }
    if ("width" in element) {
      computedWidth = width ?? element.width;
    }
    if ("sx" in element) {
      computedSx = sx ?? element.sx;
    }
  }
  return /* @__PURE__ */ jsx(
    CustomSingleSkeleton,
    {
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      height: computedHeight,
      hiddenText,
      variant,
      sx: computedSx,
      width: computedWidth
    }
  );
};
Skeleton.displayName = COMPONENT_NAME;
export {
  Skeleton,
  SkeletonVariant
};
